export default {
	entryPage: {
		frameTitle: "Startseite von {dataspace}",
		openProcesses: "Prozesse",
		loading: "Startseite wird geladen…",
		loadFailed: "Die Startseite konnte nicht geladen werden.",
		startUnavailable: "Ein Prozess „{name}“ kann hier nicht gestartet werden.",
		startForbidden: "Sie dürfen in diesem Dataspace keine Prozesse starten.",
		startNeedsClick: "Ein Prozess lässt sich nur mit einem Klick auf der Seite starten.",
		startBusy: "Es wird bereits ein Prozess gestartet; versuchen Sie es gleich noch einmal.",
		startFailed: "Der Prozess konnte nicht gestartet werden.",
		startNotReady: "„{name}“ wurde gestartet, ist aber nicht angelaufen: {reason}",
		startNotReadyTimeout: "Er hat nicht rechtzeitig gemeldet, dass er bereit ist",
		startNotReadyStatus: "sein Status ist „{status}“",
		eventForbidden: "Sie dürfen in diesem Dataspace keine Ereignisse an Prozesse senden.",
		eventBusy: "Zu viele Ereignisse auf einmal; versuchen Sie es gleich noch einmal.",
		eventUnknownProcess: "Einen Prozess „{name}“ gibt es hier nicht.",
		eventFailed: "Das Ereignis konnte nicht gesendet werden.",
	},
};
